<template>
  <div class="no-loan">
    <v-container class="pa-0 mb-0 mb-md-8">
      <div class="card">
        <v-card
          class="transparent px-4 py-3 px-md-6 pt-10 pb-6"
          elevation="0"
          flat
          tile
        >
          <v-row>
            <!-- Main -->
            <v-col cols="12">
              <!-- Your next loan is waiting for you -->
              <h1 class="header-h1">Your next loan is waiting for you</h1>
            </v-col>

            <!-- Left -->
            <v-col cols="12" sm="6" md="8">
              <p class="b-body-1 mt-1">
                Please check your
                <router-link
                  class="b-body-1"
                  :to="{ name: 'DashboardPersonalDataPage' }"
                >
                  personal data
                </router-link>
                before submitting your application.
              </p>

              <!-- Apply for loan -->
              <!-- Desktop -->
              <!-- <div class="hidden-xs-only">
                <v-btn
                  :to="{ name: 'CreateLoanApplicationPage' }"
                  class="b-button primary text-capitalize px-8"
                  height="48"
                  elevation="0"
                >
                  Apply for loan
                </v-btn>
              </div> -->

              <!-- Mobile -->
              <!-- <div class="hidden-sm-and-up">
                <v-btn
                  :to="{ name: 'CreateLoanApplicationPage' }"
                  class="b-button primary text-capitalize"
                  height="48"
                  block
                  elevation="0"
                >
                  Apply for loan
                </v-btn>
              </div> -->

              <!-- Apply for loan -->
              <!-- Desktop -->
              <div class="hidden-xs-only">
                <v-btn
                  @click="redirectToExternal"
                  class="b-button primary text-capitalize px-8"
                  height="48"
                  elevation="0"
                >
                  Apply for loan
                </v-btn>
              </div>

              <!-- Mobile -->
              <div class="hidden-sm-and-up">
                <v-btn
                  @click="redirectToExternal"
                  class="b-button primary text-capitalize"
                  height="48"
                  block
                  elevation="0"
                >
                  Apply for loan
                </v-btn>
              </div>
            </v-col>

            <!-- Right -->
            <v-col cols="12" sm="6" md="4">
              <v-img
                alt="Completed"
                class="completed"
                contain
                src="@/assets/img/public/pages/registration/completed.svg"
                max-width="288"
              />
            </v-col>
          </v-row>
          <!-- <v-dialog v-model="dialog" max-width="600" persistent>
            <v-card class="promo-dialog">
              <div class="promo-content">
               
                <div class="promo-header">
                  <h1 class="promo-title">APPLY WITH</h1>
                  <h2 class="promo-subtitle">
                    CENTURY FINANCIAL SERVICES AND WIN BIG!
                  </h2>
                  <p class="promo-prize">5 cash prizes of R10,000 each</p>
                </div>

                <div class="promo-terms">
                  <h3 class="terms-title">T&Cs</h3>
                  <ul class="terms-list">
                    <li>
                      Apply and get a loan between 4 Sep – 4 Oct to qualify
                    </li>
                    <li>Entry automatic on loan payout</li>
                    <li>Winnings paid within 7 days</li>
                    <li>Data use per POPIA</li>
                  </ul>
                </div>

                <div class="promo-actions">
                  <v-btn
                    class="century-btn"
                    @click="redirectToExternal"
                    depressed
                    rounded
                  >
                    Apply with Century
                  </v-btn>
                  <v-btn class="lime-btn" @click="stayOnLime" depressed rounded>
                    Apply with Lime
                  </v-btn>
                </div>

                <div class="promo-footer">
                  <p>No re-registration needed – just log in and apply</p>
                </div>
              </div>
            </v-card>
          </v-dialog> -->
        </v-card>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "LimeLoansNoLoan",

  data() {
    return {
      // dialog: false,
      // previous_active_loan_count: 0,
      // numLoansNeededToShowDialog: 2,
    };
  },

  computed: {
    ...mapState({ auth: "auth" }),
  },

  mounted() {},

  created() {
    // Get User Details After 1 Second
    setTimeout(() => {
      // getUserDetails
      this.getUserDetails();
    }, 1000);

    const user = this.$store.getters["auth/getUser"];
    // this.previous_active_loan_count = user.previous_active_loan_count || 0;
  },

  methods: {
    ...mapActions({
      getApiUserDetails: "auth/getApiUserDetails",
    }),

    // getUserDetails
    async getUserDetails() {
      await this.getApiUserDetails();
    },

    async redirectToExternal() {
      window.location.href =
        "https://creditza.co.za/password-recovery?from=external";

      // await this.createLog();
    },

    // async stayOnLime() {
    //   await this.createLog(false);

    //   this.$router.push({ name: "CreateLoanApplicationPage" });
    // },

    // openDialog() {
    //   this.dialog = true;
    // },

    // applyForLoanClicked() {
    //   if (this.previous_active_loan_count >= this.numLoansNeededToShowDialog) {
    //     this.dialog = true;
    //   } else {
    //     this.dialog = false;
    //     this.$router.push({ name: "CreateLoanApplicationPage" });
    //   }
    // },

    // async createLog() {
    //   const getIdNumber = this.auth.idnumber;
    //   let message = "";

    //   message = "User ID " + getIdNumber + " redirected to Century";

    //   try {
    //     await this.axios.post("redirect", {
    //       created_at: new Date().toISOString(),
    //       deleted_at: null,
    //       message: message,
    //       request: "/api/redirect",
    //       response: "N/A",
    //       site_name: "Lime Loans",
    //       status_code: 200,
    //       updated_at: new Date().toISOString(),
    //     });
    //   } catch (error) {
    //     let data = {};

    //     if (error && error.response && error.response.data) {
    //       data = error.response.data;
    //     }

    //     const status =
    //       error && error.response && error.response.status
    //         ? error.response.status
    //         : 500;

    //     this.$helpers.handleError(status, data);
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.promo-dialog {
  background-color: #fef9f1;
  border-radius: 16px;
  overflow: hidden;
  border: 3px solid #1a2f49;
}

.promo-content {
  padding: 32px 24px;
  text-align: center;
  color: #1a2f49;
}

.promo-header {
  margin-bottom: 24px;

  .promo-title {
    font-size: clamp(1.5rem, 2.5vw, 2.5rem);
    font-weight: 900;
    color: #1a2f49;
    margin-bottom: 8px;
    line-height: 1.1;
  }

  .promo-subtitle {
    font-size: clamp(1.2rem, 2vw, 1.8rem);
    font-weight: 900;
    color: #1a2f49;
    margin-bottom: 16px;
    line-height: 1.2;
  }

  .promo-prize {
    font-size: clamp(1rem, 1.5vw, 1.3rem);
    font-weight: 600;
    color: #1a2f49;
    margin-bottom: 0;
  }
}

.promo-terms {
  background-color: rgba(26, 47, 73, 0.05);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  text-align: left;

  .terms-title {
    font-size: clamp(1rem, 1.2vw, 1.2rem);
    font-weight: 700;
    color: #1a2f49;
    margin-bottom: 12px;
    text-align: center;
  }

  .terms-list {
    // list-style: none;
    padding: 10;
    margin: 0;

    li {
      font-size: clamp(0.85rem, 1vw, 1rem);
      color: #1a2f49;
      margin-bottom: 8px;
      position: relative;
      line-height: 1.4;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.promo-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;

  @media (min-width: 600px) {
    flex-direction: row;
    justify-content: center;
  }

  .century-btn {
    background-color: #1a2f49 !important;
    color: white !important;
    font-weight: 700 !important;
    font-size: clamp(0.9rem, 1vw, 1rem) !important;
    height: 48px !important;
    min-width: 180px;
    text-transform: none !important;

    &:hover {
      background-color: #0f1f2f !important;
    }
  }

  .lime-btn {
    background-color: #4caf50 !important;
    color: white !important;
    font-weight: 700 !important;
    font-size: clamp(0.9rem, 1vw, 1rem) !important;
    height: 48px !important;
    min-width: 180px;
    text-transform: none !important;

    &:hover {
      background-color: #388e3c !important;
    }
  }
}

.promo-footer {
  border-top: 1px solid rgba(26, 47, 73, 0.2);
  padding-top: 16px;

  p {
    font-size: clamp(0.75rem, 0.9vw, 0.9rem);
    color: #666;
    margin: 0;
    line-height: 1.3;
  }
}

// Mobile optimizations
@media (max-width: 599px) {
  .promo-content {
    padding: 24px 16px;
  }

  .promo-terms {
    padding: 16px;
  }
}
</style>
